(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-compatible-chassis-yokomo"] && !Shopify.designMode) return;
  try {
    /**
   * 「対応シャーシ」の品番を、公開中の商品だけ `商品名（品番）` のリンクに置き換える（#650）。
   * 一覧（先頭分・「さらに表示」の中）が画面に入ったときに、その中の品番だけを引く。
   * `/products/<品番>?view=kitref` が JSON を返せば公開中、404・転送・JSON 以外なら品番のまま。
   */
  class CompatibleKitsYokomo extends HTMLElement {
    static concurrency = 12;

    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.cache = new Map();
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.observer.unobserve(entry.target);
          this.resolveGroup(entry.target);
        }
      });
      this.querySelectorAll('[data-kit-group]').forEach((group) => this.observer.observe(group));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async resolveGroup(group) {
      const items = Array.from(group.querySelectorAll('[data-kit-handle]'));
      let next = 0;
      const worker = async () => {
        while (next < items.length) {
          const item = items[next++];
          const kit = await this.fetchKit(item.dataset.kitHandle);
          if (kit) this.renderLink(item, kit);
        }
      };
      await Promise.all(Array.from({ length: CompatibleKitsYokomo.concurrency }, worker));
    }

    fetchKit(handle) {
      if (!this.cache.has(handle)) {
        const root = window.Shopify?.routes?.root || '/';
        const url = `${root}products/${encodeURIComponent(handle)}?view=kitref`;
        // 公開されていない品番は通常の 404 ページ（圧縮後でも約80KB）が返るので、ステータスを見た時点で受信を打ち切る
        // （404 には `?view=` の代替テンプレートが効かず、軽い応答にできない）
        const controller = new AbortController();
        const request = fetch(url, { credentials: 'same-origin', signal: controller.signal })
          .then((response) => {
            if (!response.ok || response.redirected) {
              controller.abort();
              return null;
            }
            return response.json();
          })
          .then((kit) => (kit && typeof kit.u === 'string' && typeof kit.t === 'string' ? kit : null))
          .catch(() => null);
        this.cache.set(handle, request);
      }
      return this.cache.get(handle);
    }

    renderLink(item, kit) {
      const code = item.dataset.kitCode;
      const title = kit.t.trim();
      const link = document.createElement('a');
      link.className = 'pdp-compatible-chassis__link';
      link.href = kit.u;
      // 商品名が品番そのもの（生産終了品の置き場ページ）や「非公開: 品番」（旧 WP の名残）なら品番だけ
      link.textContent =
        !title || title.toUpperCase() === code.toUpperCase() || title.startsWith('非公開') ? code : `${title}（${code}）`;
      item.replaceChildren(link);
    }
  }

  if (!customElements.get('compatible-kits-yokomo')) {
    customElements.define('compatible-kits-yokomo', CompatibleKitsYokomo);
  }
  } catch(e) { console.error(e); }
})();

})();
